module.exports = __webpack_public_path__ + "img/6_55.eec2175d.png";